import { FC, HTMLAttributes } from 'react'
export const Divider: FC<HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => {
  return <div {...rest} className={`h-px w-full ${className || 'bg-neutral-300'}`} />
}
export default Divider
